import WinnerCategories from "../../../../components/PromoForm/items/WinnerCategoris";
import WinnersCount from "../../../../components/PromoForm/items/WinnersCount";
import React from "react";

export default function PromoPaticipants({create}){
    return(
        <div className={'flex h-[120px] w-full flex-col items-center justify-center rounded-xl border border-white/10 bg-white/[0.04] backdrop-blur-xl'}>
            <div className={'flex w-full flex-row pl-2'}>
            <div className={'rounded-lg border border-white/10 bg-white/[0.08] px-2 py-0.5 text-sm font-medium text-white/90'}>3 Participants / winners </div>
            </div>
            <div className={'w-[400px] flex flex-col'}>
            <WinnersCount create={create} />
            </div>
        </div>
    )
}
